var exports = {
  "kL": "MatureContentChannelGate.module__container___cHZ1Nm",
  "Qs": "MatureContentChannelGate.module__content___cHZ1Nm",
  "DD": "MatureContentChannelGate.module__title___cHZ1Nm",
  "h_": "MatureContentChannelGate.module__description___cHZ1Nm",
};

module.exports = exports;
